export default class LocalStore<T> {
  storeName: string

  constructor(storeName: string) {
    this.storeName = storeName
  }

  public getData(): T | null {
    try {
      const item = localStorage.getItem(this.storeName)
      if (item != null) return JSON.parse(item)
    } catch {
      return null
    }
    return null
  }

  public setData(data: T) {
    localStorage.setItem(this.storeName, JSON.stringify(data))
  }

  public removeData() {
    localStorage.removeItem(this.storeName)
  }

  /**
   * Criar item temporário com data de expiração
   * @param data Dados <T> a serem armazenados
   * @param expiryInMilliseconds Tempo de expiração em milissegundos
   */
  public setDataWithExpiry(data: T, expiryInMilliseconds: number) {
    const now = new Date()
    const item = {
      value: data,
      expiry: now.getTime() + expiryInMilliseconds
    }
    localStorage.setItem(`${this.storeName}_temp`, JSON.stringify(item))
  }

  /**
   * Carrega o item temporário se não estiver expirado
   * @returns Retorna o item temporário se não estiver expirado, caso contrário retorna null
   */
  public getDataWithExpiry(): T | null {
    try {
      const itemString = localStorage.getItem(`${this.storeName}_temp`)

      if (!itemString) {
        return null
      }

      const item = JSON.parse(itemString)
      const now = new Date()

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(`${this.storeName}_temp`)
        return null // Item expirado
      }

      return item.value
    } catch {
      return null
    }
  }
}
